import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const UnsubscribeLandingPage = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/NewsletterSubscription/UnsubscribeLandingPage'
    ).then(mod => ({default: mod.UnsubscribeLandingPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
